/**
 * @generated SignedSource<<9b0364203a2ccc0d835540423488d8ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FinalInvoiceViewDownloadPdfMutation$variables = {
  id: string;
};
export type FinalInvoiceViewDownloadPdfMutation$data = {
  readonly downloadInvoicePdf: {
    readonly filename: string;
    readonly uri: string;
  } | null | undefined;
};
export type FinalInvoiceViewDownloadPdfMutation = {
  response: FinalInvoiceViewDownloadPdfMutation$data;
  variables: FinalInvoiceViewDownloadPdfMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TemporaryDownload",
    "kind": "LinkedField",
    "name": "downloadInvoicePdf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FinalInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FinalInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "be68977308aecbc4c6bef88a43373cac",
    "id": null,
    "metadata": {},
    "name": "FinalInvoiceViewDownloadPdfMutation",
    "operationKind": "mutation",
    "text": "mutation FinalInvoiceViewDownloadPdfMutation(\n  $id: ID!\n) {\n  downloadInvoicePdf(input: {id: $id}) {\n    uri\n    filename\n  }\n}\n"
  }
};
})();

(node as any).hash = "97f7ec91e8244ae00ea537a310cdffaa";

export default node;
